import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { MainLayout } from '../main-layout';
import { articleList } from './styles';
import { getTitle } from '../../features/page-model/ducks/get-model';
import { response } from '../../__mocks__/response';
import { useParams, useSearch, Link } from '@okapi/router-react';
import { Pagination } from '../../common/components/paginations';
import { ArticlesType } from '../../features/articles-type';
import { ArticlesCategory } from '../../features/articles-category';
import { ArticlesTabFilter } from '../../features/articles-tab-filter';

// TODO много хардкода. в том числе и группы с типами т.к. эта информация из хардкода.
export const AdviceList = () => {
  const title = useSelector(getTitle);
  const params = useParams();
  const [search, setSearch] = useSearch();
  const [maxArticlesOnPage, setMaxArticlesOnPage] = useState(9);
  const articles = response.items;

  let listForRender = [...articles];

  if (search.type) {
    listForRender = listForRender.filter(i => i.type_slug === search.type);
  }

  if (search.format) {
    listForRender = listForRender.filter(i => (search.format === 'video' ? i.is_video : !i.is_video));
  }

  if (params.type) {
    listForRender = listForRender.filter(i => i.dept_slug === params.type);
  }

  const currentPage = Number(search.page ?? 1);

  const firstIndex = (currentPage ? currentPage - 1 : 0) * maxArticlesOnPage;
  const lastIndex = firstIndex + maxArticlesOnPage;

  const items = listForRender.slice(firstIndex, lastIndex);

  if (!items.length) return null;

  return (
    <MainLayout>
      <div className={articleList}>
        <section className="container">
          <div id="articles-list-content" className="row">
            <div className="container articles">
              <div className="row">
                {/* TODO: Заголовок */}
                <div className="col-lg-12 col-sm-12 col-xs-12">
                  <div className="page-title">
                    <h1 className="page-title-inner">{title}</h1>
                  </div>
                </div>
                <div className="col-lg-3 col-md-3 hidden-sm hidden-xs">
                  {/* TODO: Меню выбора типа */}
                  <div className="articles__articles-type-container">
                    <div className="articles-left-menu-element">
                      <div className="article-type-header">
                        <div className="left-gap"></div>
                        <p>По типу</p>
                      </div>
                      <ArticlesType />
                    </div>
                  </div>
                  {/* TODO: Меню выбора категории */}
                  <div className="articles__articles-category-container">
                    <div className="articles-left-menu-element">
                      <div className="article-type-header">
                        <div className="left-gap"></div>
                        <p>По отделу</p>
                      </div>
                      <ArticlesCategory />
                    </div>
                  </div>
                </div>
                <div className="col-lg-9 col-md-9 col-sm-12 col-xs-12 articles-right-space">
                  {/* TODO: Меню выбора вида контента */}
                  <ArticlesTabFilter />
                  {/* TODO: Меню выбора карточек с контентом */}
                  <div className="articles-content">
                    {items.map(item => {
                      return (
                        <Link
                          to={`/advice/${item.dept_slug}/${item.link}/`}
                          key={item.id}
                          className="article-link">
                          <div className="article-preview">
                            <div className="article-preview__img-container">
                              <picture>
                                <source media="(max-width: 599px)" srcSet={item.preview_srcset} />
                                <img
                                  className="article-preview__img"
                                  alt={item.title}
                                  srcSet={item.preview_srcset}
                                  src={item.preview_srcset.split(' ')[0]}
                                />
                              </picture>
                            </div>
                            <div className="article-preview__block">
                              <div className="article-preview__info-how">{item.type}</div>
                              <div className="article-preview__info-date">{item.date_publish}</div>
                              <div className="article-preview__title">
                                {item.title}
                                <div className="article-preview__deck"> {item.description}</div>
                              </div>
                              <div className="article-preview__social" />
                            </div>
                          </div>
                        </Link>
                      );
                    })}
                  </div>
                  {/* TODO: Пагинация хз что делать с подгрузкой */}
                  <div className="articles-pagination">
                    <div className="paginator-show-more">
                      <div
                        className="articles-show-more"
                        onClick={() => setMaxArticlesOnPage(maxArticlesOnPage + 3)}>
                        {/* <img
                          className="articles__show-more-img"
                          src="https://leroymerlin.ru/etc/designs/elbrus/images/articles/show-more.svg"
                          alt=""
                        /> */}
                        <p>ПОКАЗАТЬ ЕЩЁ</p>
                      </div>
                    </div>
                    <Pagination
                      currentPage={currentPage}
                      totalCount={listForRender.length}
                      pageSize={maxArticlesOnPage}
                      onPageChange={page => {
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        /* @ts-ignore */
                        setSearch({ ...search, page });
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </MainLayout>
  );
};
